<template>
  <modal :show="show" :large="true" v-on:close="closeModal">
    <div slot="title">
      <h4>Edit Overpayment</h4>
    </div>
    <div class="row">
      <div class="col-xl-12">
        <div class="form-horizontal">
          <datepicker-input
            name="overpayment_date"
            label="Overpayment Date"
            helper="Please enter the overpayment date"
            v-model="form.overpayment_date"
          ></datepicker-input>

          <currency-input
            name="overpayment_value"
            label="Overpayment Amount"
            :value="form.value"
            @input="updateOverpaymentValue"
          ></currency-input>

          <input-block
            name="comment"
            label="Overpayment Comment"
            v-model="form.comment"
          ></input-block>

          <datepicker-input
            name="return_date"
            label="Overpayment Return Date"
            helper="Please enter the overpayment return date"
            v-model="form.return_date"
          ></datepicker-input>
        </div>
      </div>
    </div>
    <div slot="footer">
      <div class="float-left">
        <form-button
          level="danger"
          :indicator="deleting"
          v-on:clicked="deleteOverpayment"
        >
          Delete Overpayment
        </form-button>
      </div>
      <div class="float-right">
        <button type="button" v-on:click="closeModal" class="btn btn-danger">
          Close
        </button>
        <form-button :indicator="form.processing()" v-on:clicked="save">
          Save Overpayment
        </form-button>
      </div>

      <div class="clearfix"></div>
    </div>
  </modal>
</template>
<script>
import CurrencyInput from '@/components/Generic/Form/CurrencyInput';

export default {
  components: {
    CurrencyInput
  },

  props: {
    overpayment: {
      type: Object,
      required: true
    },
    incident: {
      type: String,
      required: true
    },
    recovery: {
      type: Object,
      required: true
    },
    show: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      form: new window.Form({
        overpayment_date: null,
        value: 0,
        comment: null,
        return_date: null
      }),
      deleting: false
    };
  },

  mounted() {
    this.setDefault();
  },

  watch: {
    overpayment: {
      handler() {
        this.setDefault();
      },
      immediate: true
    },
    'form.return_date'(val) {
      if (val) {
        this.form.value = 0;
      }
    }
  },

  methods: {
    updateOverpaymentValue(value) {
      this.form.value = value;
    },

    setDefault() {
      this.form.overpayment_date = this.overpayment.overpayment_date
        ? new Date(this.overpayment.overpayment_date)
        : null;
      this.form.value = this.overpayment.value;
      this.form.comment = this.overpayment.comment;
      this.form.return_date = this.overpayment.return_date
        ? new Date(this.overpayment.return_date)
        : null;
    },

    closeModal() {
      this.$emit('close');
    },

    save() {
      this.form
        .put(
          `/debt-recovery/${this.incident}/overpayments/${this.overpayment.identifier}`
        )
        .then(response => {
          window.toastify.success(
            'Success',
            'The overpayment was updated successfully!'
          );
          this.closeModal();
        })
        .catch(error => {
          window.toastify.error(
            'Sorry, there was a problem saving the overpayment'
          );
        });
    },

    deleteOverpayment() {
      window
        .swal({
          title: 'Are you sure?',
          text: 'This will permanently remove the overpayment',
          type: 'warning',
          showCancelButton: true
        })
        .then(() => {
          this.deleting = true;

          window.Ajax.delete(
            `/debt-recovery/${this.incident}/overpayments/${this.overpayment.identifier}`
          )
            .then(() => {
              window.toastify.success(
                'Success',
                'The overpayment was deleted successfully!'
              );
              this.closeModal();
            })
            .catch(() => {
              window.toastify.error(
                'Sorry, there was a problem deleting the overpayment'
              );
            });
        });
    }
  }
};
</script>
